import Typograf from 'typograf'
import {LangObject} from "@brg/api/dist/api-core/utils/lang-utils";

export const executeTypograf = (rawText: string) => {
    const tp = new Typograf({locale: ['ru', 'en-US']});
    return tp.execute(rawText)
}

export const executeTypografLangObject = (text: LangObject[]) => {
    const tp = new Typograf({locale: ['ru', 'en-US']});
    return text.map(item => ({...item, text: tp.execute(item?.name || '')}))
}import Typograf from 'typograf'
import {LangObject} from "@brg/api/dist/api-core/utils/lang-utils";

export const executeTypograf = (rawText: string) => {
    const tp = new Typograf({locale: ['ru', 'en-US']});
    return tp.execute(rawText)
}

export const executeTypografLangObject = (text: LangObject[]) => {
    const tp = new Typograf({locale: ['ru', 'en-US']});
    return text.map(item => ({...item, text: tp.execute(item?.name || '')}))
}